import { i18n } from "@/plugins/i18n";
export default {
  items: [
    // {
    //   name: i18n.global.t("menu.appli"),
    //   url: "/cabinet/console/aplicationprocess",
    //   icon: "icon-cabinet-applications-white.svg",
    //   iconDisabled: "icon-cabinet-applications-disabled.svg",
    //   iconPink: "icon-cabinet-applications-pink.svg",
    //   scopes: [""],
    // },
    {
      name: i18n.global.t("menu.account"),
      url: "/cabinet/console/accounts",
      icon: "icon-cabinet-accounts-white.svg",
      iconDisabled: "icon-cabinet-accounts-disabled.svg",
      iconPink: "icon-cabinet-accounts-pink.svg",
      scopes: [""],
    },
    {
      name: i18n.global.t("menu.platforms"),
      url: "/cabinet/console/platforms",
      icon: "icon-cabinet-platforms-white.svg",
      iconDisabled: "icon-cabinet-platforms-disabled.svg",
      iconPink: "icon-cabinet-platforms-pink.svg",
      scopes: [""],
    },
    {
      name: i18n.global.t("menu.history"),
      url: "/cabinet/console/history",
      icon: "icon-cabinet-history-white.svg",
      iconDisabled: "icon-cabinet-history-disabled.svg",
      iconPink: "icon-cabinet-history-pink.svg",
      scopes: [""],
    },
    {
      name: i18n.global.t("menu.deposit"),
      url: "/cabinet/console/deposit",
      icon: "icon-cabinet-deposit-white.svg",
      iconDisabled: "icon-cabinet-deposit-disabled.svg",
      iconPink: "icon-cabinet-deposit-pink.svg",
      scopes: [""],
    },
    {
      name: i18n.global.t("menu.transfer"),
      url: "/cabinet/console/transfer",
      icon: "icon-cabinet-transfer-white.svg",
      iconDisabled: "icon-cabinet-transfer-disabled.svg",
      iconPink: "icon-cabinet-transfer-pink.svg",
      scopes: [""],
    },
    {
      name: i18n.global.t("menu.withdraw"),
      url: "/cabinet/console/withdraw",
      icon: "icon-cabinet-withdraw-withe.svg",
      iconDisabled: "icon-cabinet-withdraw-disabled.svg",
      iconPink: "icon-cabinet-withdraw-pink.svg",
      scopes: [""],
    },
    // {
    //     name: 'Tools',
    //     url: null,
    //     icon: 'cabinet_menu_tools.svg',
    //     scopes: [''],
    //     children: [
    //         {
    //             name: 'Calendar',
    //             url: '/cabinet/console/calendar',
    //             icon: '',
    //             scopes: ['']
    //         },
    //         {
    //             name: 'Calculator',
    //             url: '/cabinet/console/calculator',
    //             icon: '',
    //             scopes: ['']
    //         },
    //     ]
    // },
    {
      name: i18n.global.t("menu.settings"),
      url: null,
      icon: "icon-cabinet-settings-white.svg",
      iconDisabled: "icon-cabinet-settings-disabled.svg",
      iconPink: "icon-cabinet-settings-pink.svg",
      scopes: [""],
      children: [
        {
          name: i18n.global.t("menu.passwordsettings"),
          url: "/cabinet/console/password",
          icon: "icon-cabinet-password-white.svg",
          iconPink: "icon-cabinet-password-pink.svg",
          scopes: [""],
        },
        // {
        //     name: 'Language settings',
        //     url: '/cabinet/console/language',
        //     icon: 'icon-cabinet-language-white.svg',
        //     scopes: ['']
        // },
        {
          name: i18n.global.t("menu.emailsettings"),
          url: "/cabinet/console/email",
          icon: "icon-cabinet-email-white.svg",
          iconPink: "icon-cabinet-email-pink.svg",
          scopes: [""],
        },
        /*{
          name: i18n.global.t("menu.authenticationsettings"),
          url: "/cabinet/console/mfa",
          icon: "icon-cabinet-authentication-white.svg",
          iconPink: "icon-cabinet-authentication-pink.svg",
          scopes: [""],
        },*/
      ],
    },
    {
      name: i18n.global.t("menu.contactUs"),
      url: "/cabinet/console/contact_us",
      icon: "icon-cabinet-support-white.svg",
      iconDisabled: "icon-cabinet-support-disabled.svg",
      iconPink: "icon-cabinet-support-pink.svg",
      scopes: [""],
    },
  ],
};
